import DatePicker, { ReactDatePickerProps } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ptBR from "date-fns/locale/pt-BR";
import { registerLocale } from "react-datepicker";
import {
  IInputContainerProps,
  InputContainer,
} from "../InputContainer/inputContainer";

import * as S from "./styles";

type IInputCalendarProps = IInputContainerProps & ReactDatePickerProps;
export const InputCalendar = ({ label, ...rest }: IInputCalendarProps) => {
  registerLocale("ptBR", ptBR);

  return (
    <InputContainer label={label} required={rest.required}>
      <S.InputCalendarContainer>
        <DatePicker
          {...rest}
          renderCustomHeader={({ monthDate, decreaseMonth, increaseMonth }) => (
            <div className="react-datepicker__navigation_wrapper">
              <button
                type="button"
                aria-label="Previous Month"
                className={
                  "react-datepicker__navigation react-datepicker__navigation--previous"
                }
                onClick={decreaseMonth}
              >
                <span
                  className={
                    "react-datepicker__navigation-icon react-datepicker__navigation-icon--previous"
                  }
                >
                  {"<"}
                </span>
              </button>
              <span className="react-datepicker__current-month">
                {monthDate.toLocaleString("pt-BR", {
                  month: "long",
                  year: "numeric",
                })}
              </span>
              <button
                type="button"
                aria-label="Next Month"
                className={
                  "react-datepicker__navigation react-datepicker__navigation--next"
                }
                onClick={increaseMonth}
              >
                <span
                  className={
                    "react-datepicker__navigation-icon react-datepicker__navigation-icon--next"
                  }
                >
                  {">"}
                </span>
              </button>
            </div>
          )}
          dateFormat={"dd/MM/yyyy"}
          locale={"ptBR"}
          icon={<img alt="icone calendario" src="/assets/imgs/calendar.png" />}
        />
      </S.InputCalendarContainer>
    </InputContainer>
  );
};
